/**
 * Best 3 listeners (Sam, Oct 25 2026): shown on home + dashboard.
 * Change these listing UUIDs to swap who is featured (or set
 * REACT_APP_BEST_LISTENER_IDS="uuid1,uuid2,uuid3" at build). Missing / unpublished
 * IDs are skipped and the strip fills with the top-ranked listeners
 * (Available Now → reviews → complete profile).
 * Photo required (Sam Oct 28): pins or ranked people without a real face photo
 * are never featured. The strip rotates hourly within the top ~16–24 only.
 */
const fromEnv = (process.env.REACT_APP_BEST_LISTENER_IDS || '').split(',').map(s => s.trim()).filter(Boolean);
export const BEST_LISTENER_IDS = fromEnv.length
  ? fromEnv
  : [
      '6ab5b96e-d013-4a04-b0f3-9f34c87ed461', // Jonathon
      '6a8f123f-fdda-4e36-9082-aa3a1c7cb175', // New-place loneliness
      '6a8f123c-03ce-401e-b055-ae73228eedf5', // Evening wind-down
    ];
/** Sam Oct 28: home shows 10 thumbs. */
export const BEST_LISTENER_COUNT = 10;
